module.exports = __webpack_public_path__ + "static/media/inclusion_waiting_period.9603e6ab.svg";